/* mcdwisco — English/Spanish site toggle.
   Client-side, instant, no reload. Translates at the text-node level so brand
   wordmarks, icons, and inline markup stay intact. A few reorder/highlight
   headings are handled at the element (innerHTML) level. Spanish is US-market,
   warm recruiting register (informal "tú"). Loaded on every mcdwisco page. */
(function () {
  if (window.__mcdwI18n) return; window.__mcdwI18n = true;

  function norm(s) { return (s || '').replace(/\s+/g, ' ').trim(); }

  /* ---- element-level (innerHTML) translations: reorder / highlight / wordmark headings ---- */
  var HTML = {
    'All in on Wisconsin.': 'Comprometidos con <span class="accent">Wisconsin</span>.',
    'We build a Gold Standard culture.': 'Creamos una cultura <span style="box-shadow:inset 0 -0.30em 0 rgba(255,199,44,.5)">de Estándar de Oro</span>.',
    // {W} = the heading's own logo, reused as rendered (the logo is an image, so it is not in the text key)
    'The values behind every shift.': 'Los valores de {W} en cada turno.',
    'Everything on the menu at': 'Todo lo que encontrarás en {W}',
    'This is': 'Esto es {W}'
  };

  /* ---- text-node translations (English → Spanish) ---- */
  var TEXT = {
    // topbar / shared
    'Wisconsin · Now Hiring': 'Wisconsin · Contratando',
    'What we stand for': 'Lo que representamos',
    'Now hiring': 'Contratando',
    // hero rotator (two-line headlines crafted to read correctly in Spanish order)
    'Where careers begin': 'Donde empiezan las carreras',
    'Serving our community': 'Al servicio de nuestra comunidad',
    'Quality you can taste': 'Calidad que se saborea',
    'Made with care': 'Hecho con cuidado',
    'A team that feels like family': 'Un equipo que se siente como familia',
    'Real': 'Oportunidad', 'Opportunity.': 'Real.',
    'Every': 'Cada', 'Family.': 'Familia.',
    'Gold': 'Estándar', 'Standard.': 'de Oro.',
    'Always': 'Siempre', 'Fresh.': 'Fresco.',
    'One': 'Un', 'Crew.': 'Equipo.',
    'We build careers, not just shifts, with room to rise at every restaurant.': 'Creamos carreras, no solo turnos, con espacio para crecer en cada restaurante.',
    'From first smiles to Friday nights, we show up for every family we serve.': 'De las primeras sonrisas a los viernes por la noche, estamos ahí para cada familia.',
    'We set the standard, every single order, exactly the way it should be.': 'Marcamos el estándar, en cada pedido, exactamente como debe ser.',
    'Real care at every station, every shift, made the way it should be.': 'Cuidado real en cada estación, cada turno, hecho como debe ser.',
    'A crew that looks out for each other, where everyone truly belongs.': 'Un equipo que se cuida entre sí, donde todos pertenecen de verdad.',
    'Inquire about roles →': 'Conoce las vacantes →',
    // glance
    'What you get': 'Lo que recibes',
    'Flexible scheduling': 'Horarios flexibles',
    'Shifts built around school, family, and life.': 'Turnos que se ajustan a la escuela, la familia y tu vida.',
    'Education support': 'Apoyo educativo',
    'Tuition help through Archways to Opportunity, for eligible crew.': 'Ayuda con la matrícula a través de Archways to Opportunity, para quienes califican.',
    'Hands-on training': 'Capacitación práctica',
    'Coaching, certifications, and Hamburger University.': 'Mentoría, certificaciones y la Universidad de la Hamburguesa.',
    'Room to grow': 'Espacio para crecer',
    'We promote from within, Crew to Director.': 'Promovemos desde adentro, de Equipo a Director.',
    // commitment
    'Our commitment': 'Nuestro compromiso',
    'We’re here for the long run.': 'Estamos aquí para el largo plazo.',
    'Every decision we make is about strengthening these restaurants, investing in the people who run them, and showing up for the communities they serve, year after year.': 'Cada decisión que tomamos busca fortalecer estos restaurantes, invertir en las personas que los dirigen y estar presentes para las comunidades a las que servimos, año tras año.',
    // mission
    'People first': 'Primero las personas',
    ', every guest, every shift.': ', cada cliente, cada turno.',
    'Our mission': 'Nuestra misión',
    'Our Restaurant Group builds a Gold Standard culture by leading visibly, investing in people, and running disciplined systems. That’s how we deliver great-tasting food, welcoming hospitality, safe workplaces, and growth you earn as you’re ready.': 'Our Restaurant Group construye una cultura de Estándar de Oro liderando de frente, invirtiendo en la gente y aplicando sistemas disciplinados. Así ofrecemos comida deliciosa, hospitalidad cálida, lugares de trabajo seguros y un crecimiento que ganas cuando estás listo.',
    'Lead visibly': 'Lidera de frente',
    'On the floor': 'En el piso',
    'Leaders coach in the moment and hold the standard where it happens, on the line, every shift.': 'Los líderes guían en el momento y mantienen el estándar donde sucede, en la línea, cada turno.',
    'Invest in people': 'Invierte en la gente',
    'Promote from within': 'Promover desde adentro',
    'Real training and a clear path turn a first job into a lasting career, growth you earn as you’re ready.': 'La capacitación real y un camino claro convierten un primer empleo en una carrera duradera, un crecimiento que ganas cuando estás listo.',
    'Disciplined systems': 'Sistemas disciplinados',
    'Consistency': 'Constancia',
    'Proven routines keep food great, guests welcome, and every workplace safe.': 'Las rutinas comprobadas mantienen la comida excelente, a los clientes bienvenidos y cada lugar de trabajo seguro.',
    // values
    'More than words on a wall, these are the standards we hire for and lead by, every single day.': 'Más que palabras en una pared, son los estándares por los que contratamos y lideramos, todos los días.',
    // did you know
    'Did you know?': '¿Sabías que?',
    'McDonald’s has trained its managers at': 'McDonald’s capacita a sus gerentes en',
    'Hamburger University': 'la Universidad de la Hamburguesa',
    'since 1961. When we say we’ll invest in your growth, we mean a real curriculum, not a shrug and a nametag.': 'desde 1961. Cuando decimos que invertiremos en tu crecimiento, hablamos de un plan de estudios real, no de un gafete y ya.',
    'More than three in four of McDonald’s restaurant managers started out as hourly crew. The person training you today could be running the place tomorrow.': 'Más de tres de cada cuatro gerentes de restaurante de McDonald’s empezaron como equipo por hora. La persona que te capacita hoy podría dirigir el lugar mañana.',
    'The best seat in any restaurant is the one you help build. We’re hiring the crew that sets the standard under new local ownership, and it starts on your first shift. That’s where you come in.': 'El mejor lugar en cualquier restaurante es el que tú ayudas a construir. Estamos contratando al equipo que marcará el estándar con los nuevos dueños locales, y empieza en tu primer turno. Ahí es donde entras tú.',
    'Day 1': 'Día 1',
    '3 in 4': '3 de 4',
    // crew menu
    'The crew menu': 'El menú del equipo',
    'We’re building more than restaurants. We’re building careers, and a team that has each other’s backs.': 'Estamos construyendo más que restaurantes. Construimos carreras y un equipo que se respalda entre sí.',
    'A great first job': 'Un gran primer empleo',
    'No experience needed': 'Sin experiencia necesaria',
    'New to work? Perfect. We’ll teach you real skills, teamwork, and habits that set up everything that comes next.': '¿Nuevo en el trabajo? Perfecto. Te enseñaremos habilidades reales, trabajo en equipo y hábitos que preparan todo lo que viene después.',
    'Real career growth': 'Crecimiento real de carrera',
    'Crew → Director': 'Equipo → Director',
    'We promote from within. The path runs all the way from Crew to Director. See the climb below.': 'Promovemos desde adentro. El camino va desde Equipo hasta Director. Mira el ascenso más abajo.',
    'We invest in your growth': 'Invertimos en tu crecimiento',
    'Hamburger U': 'Universidad de la Hamburguesa',
    'Tuition help through Archways to Opportunity for eligible crew, and a path to Hamburger University, McDonald’s own management college.': 'Ayuda con la matrícula a través de Archways to Opportunity para quienes califican, y un camino hacia la Universidad de la Hamburguesa, la escuela de gestión de McDonald’s.',
    'Meals on us': 'La comida corre por nuestra cuenta',
    'Free': 'Gratis',
    'Free and discounted food on every shift. You’ll eat well here.': 'Comida gratis y con descuento en cada turno. Aquí comerás bien.',
    'Schedules that flex': 'Horarios que se adaptan',
    'Your hours': 'Tus horas',
    'School, family, or a second gig, we build shifts around your real life.': 'Escuela, familia o un segundo empleo: armamos los turnos en torno a tu vida real.',
    'Ground-floor spot': 'Un lugar desde el inicio',
    'Day one': 'Día uno',
    'Join a team under new local ownership and help set the culture and the standard from your very first shift.': 'Únete a un equipo con nuevos dueños locales y ayuda a marcar la cultura y el estándar desde tu primer turno.',
    'Full-time & part-time · No experience needed to start': 'Tiempo completo y medio tiempo · Sin experiencia para empezar',
    // the climb
    'The climb': 'El ascenso',
    'Start on Crew. We’ll take you as far as you want to go.': 'Empieza en Equipo. Te llevaremos tan lejos como quieras llegar.',
    'This isn’t a stopgap job. Almost every leader started behind the counter, and we’re invested in getting you where you want to go, with': 'Este no es un empleo temporal. Casi todos los líderes empezaron detrás del mostrador, y estamos comprometidos con llevarte a donde quieres llegar, con',
    'real training, a clear path, and people in your corner': 'capacitación real, un camino claro y gente de tu lado',
    'Room to rise': 'Espacio para crecer',
    ', we invest in how far you go.': ', invertimos en qué tan lejos llegas.',
    'Proper training': 'Capacitación de verdad',
    'Hands-on coaching, McDonald’s certifications, and Hamburger University, you’ll learn the business for real.': 'Mentoría práctica, certificaciones de McDonald’s y la Universidad de la Hamburguesa: aprenderás el negocio de verdad.',
    'A clear path': 'Un camino claro',
    'Every role has a defined next step and exactly what it takes to get there. No guessing.': 'Cada puesto tiene un siguiente paso definido y lo que se necesita para llegar. Sin adivinar.',
    'People in your corner': 'Gente de tu lado',
    'Managers who coach, mentor, and genuinely want you to move up. Your growth is the goal.': 'Gerentes que te guían, aconsejan y de verdad quieren verte crecer. Tu crecimiento es la meta.',
    // stair labels (roles)
    'Crew': 'Equipo',
    'Shift Leader': 'Líder de Turno',
    'Department Manager': 'Gerente de Departamento',
    'Assistant GM': 'Subgerente General',
    'General Manager': 'Gerente General',
    'Supervisor': 'Supervisor',
    'Director of Operations': 'Director de Operaciones',
    'VP / Market Area': 'VP / Área de Mercado',
    'In the restaurant · Crew → GM': 'En el restaurante · Equipo → Gerente General',
    'Across our restaurants · Supervisor → VP': 'En todos nuestros restaurantes · Supervisor → VP',
    'From Crew on up, every step is open to you, and every one is earned.': 'De Equipo en adelante, cada paso está abierto para ti, y cada uno se gana.',
    // roles + form
    'We’re looking for people to change the game.': 'Buscamos personas para cambiar las reglas del juego.',
    'Americans have worked at McDonald’s': 'de los estadounidenses han trabajado en McDonald’s',
    'And they don’t just work here, they grow.': 'Y no solo trabajan aquí: crecen.',
    'What starts as a job turns into skills, connections, and launched futures. Crew members go on to become entrepreneurs, community leaders, and innovators. Now we’re building the teams who’ll do it in Beaver Dam and Germantown.': 'Lo que empieza como un empleo se convierte en habilidades, conexiones y futuros que despegan. Miembros del equipo llegan a ser emprendedores, líderes comunitarios e innovadores. Ahora estamos formando los equipos que lo harán en Beaver Dam y Germantown.',
    'General Managers': 'Gerentes Generales',
    'Own a restaurant end to end. Build the team, hit the standard, grow the business.': 'Dirige un restaurante de principio a fin. Forma el equipo, cumple el estándar, haz crecer el negocio.',
    'Shift Leaders': 'Líderes de Turno',
    'Run a great shift. Set the pace, coach the crew, deliver for every guest.': 'Dirige un gran turno. Marca el ritmo, guía al equipo, cumple para cada cliente.',
    'The heart of the restaurant. Bring the energy; we’ll bring the training and the path up.': 'El corazón del restaurante. Tú pon la energía; nosotros ponemos la capacitación y el camino hacia arriba.',
    'Your next chapter starts here.': 'Tu próximo capítulo empieza aquí.',
    'Start the conversation': 'Empecemos a conversar',
    'Tell us a little about you. We’ll be in touch soon, no résumé required to say hello.': 'Cuéntanos un poco sobre ti. Te contactaremos pronto, no necesitas currículum para saludar.',
    'I’m interested in': 'Me interesa',
    'Open to talk': 'Abierto a conversar',
    'Please pick a role above.': 'Elige un puesto arriba.',
    'First name': 'Nombre',
    'Last name': 'Apellido',
    'Email': 'Correo electrónico',
    'Phone': 'Teléfono',
    'Have you worked at McDonald’s before?': '¿Has trabajado en McDonald’s antes?',
    'Yes': 'Sí',
    'No': 'No',
    'Anything you’d like us to know?': '¿Algo que quieras contarnos?',
    'Submit interest →': 'Enviar mi interés →',
    'No experience needed for Crew': 'No necesitas experiencia para Equipo',
    'We reply fast': 'Respondemos rápido',
    'Your info stays private': 'Tu información es privada',
    'Prefer email?': '¿Prefieres correo?',
    'Please check the highlighted fields and try again.': 'Revisa los campos marcados e intenta de nuevo.',
    'Thanks, we’ve got it.': 'Gracias, lo recibimos.',
    'We’re grateful you reached out. Our team will follow up soon.': 'Agradecemos que nos hayas escrito. Nuestro equipo te contactará pronto.',
    // in good company
    'In good company': 'En buena compañía',
    'You’d be joining a brand people have loved for generations.': 'Te unirías a una marca que la gente ha querido por generaciones.',
    'Every shift, our crews turn an everyday stop into a good one, for families, for friends, for the regulars who feel like part of the place.': 'En cada turno, nuestros equipos convierten una parada cualquiera en una buena, para familias, para amigos, para los clientes de siempre que se sienten parte del lugar.',
    // party promo (mcdwisco-party.liquid) + footer link; the party site itself is English only
    'Birthday parties': 'Fiestas de cumpleaños',
    'The party’s at our place.': 'La fiesta es en nuestra casa.',
    'Both of our restaurants host birthday parties. Plan yours on our party site, then call the restaurant or ask anyone at our counter to book.': 'Nuestros dos restaurantes organizan fiestas de cumpleaños. Planea la tuya en nuestro sitio de fiestas y luego llama al restaurante o pregunta a cualquiera de nuestro equipo en el mostrador para reservar.',
    'A decorated party room with activities, for up to 20 kids': 'Un salón de fiestas decorado con actividades, para hasta 20 niños',
    'PlayPlace parties for up to 30 kids': 'Fiestas en el PlayPlace para hasta 30 niños',
    'Add a McDonald’s birthday cake for $39 or a visit from Grimace for $100. Book 7 to 120 days ahead.': 'Agrega un pastel de cumpleaños de McDonald’s por $39 o una visita de Grimace por $100. Reserva con 7 a 120 días de anticipación.',
    'Parties from': 'Fiestas desde',
    '10 kids included': '10 niños incluidos',
    'Plan a party →': 'Planea una fiesta (en inglés) →',
    'Birthdays are better with fries.': 'Los cumpleaños son mejores con papas fritas.',
    'Bring the birthday kid and their friends. We’ll bring the Happy Meals, the party and plenty of smiles. Plan it on our party site, then call us or ask anyone at our counter.': 'Trae al cumpleañero y a sus amigos. Nosotros ponemos las Cajitas Felices, la fiesta y muchas sonrisas. Planéala en nuestro sitio de fiestas y luego llámanos o pregunta a cualquiera de nuestro equipo en el mostrador.',
    'Our decorated party room, with crafts, coloring and party music. Up to 20 kids.': 'Nuestro salón de fiestas decorado, con manualidades, dibujos para colorear y música. Hasta 20 niños.',
    'Climb, slide and play in the PlayPlace. Up to 30 kids.': 'A trepar, deslizarse y jugar en el PlayPlace. Hasta 30 niños.',
    'Add the McDonald’s birthday cake for $39, or a visit from Grimace for $100. Book at least a week ahead.': 'Agrega el pastel de cumpleaños de McDonald’s por $39 o una visita de Grimace por $100. Reserva con al menos una semana de anticipación.',
    'Plan the party →': 'Planea la fiesta (en inglés) →',
    'Party at our place!': '¡La fiesta es en nuestra casa!',
    'Both restaurants · from $179': 'En los dos restaurantes · desde $179',
    'Parties': 'Fiestas',  // footer link to the party site AND the topbar nav link to #parties
    // footer
    'Ownership · Respect · Growth': 'Compromiso · Respeto · Crecimiento',
    '© 2026 Our Restaurant Group. McDonald’s and the Golden Arches are trademarks of McDonald’s Corporation, used with permission.': '© 2026 Our Restaurant Group. McDonald’s y los Arcos Dorados son marcas registradas de McDonald’s Corporation, usadas con permiso.',
    'Privacy policy': 'Política de privacidad',
    'Staff sign-in': 'Acceso del personal',
    // Crew Radio chip (homepage). It floats outside .mcdw, so applyTEXT also walks .mrc-chip.
    'Happy, positive tunes': 'Música alegre y positiva',
    // ===== password gate =====
    'Opening soon. Have the password? Otherwise, say hello —': 'Próxima apertura. ¿Tienes la contraseña? Si no, salúdanos —',
    'Enter →': 'Entrar →',
    'That’s not it — double-check and try again.': 'Esa no es — revísala e intenta de nuevo.',
    'Crew log in': 'Acceso para equipo',
    // gate WISCO values
    'World-class': 'De clase mundial',
    'We serve food that’s hot, fresh, and made right, every order and every shift. The standard never moves.': 'Servimos comida caliente, fresca y bien hecha, en cada pedido y cada turno. El estándar nunca baja.',
    'Inclusive': 'Inclusivos',
    'Everyone has a place here and a fair shot to grow. We hire for character, we build A-players, and we look after our people.': 'Aquí todos tienen un lugar y una oportunidad justa de crecer. Contratamos por carácter, formamos a los mejores y cuidamos a nuestra gente.',
    'Service': 'Servicio',
    'The guest comes first, always. Fast, warm, accurate, and a reason to come back.': 'El cliente es primero, siempre. Rápido, cálido, exacto y con una razón para volver.',
    'Community': 'Comunidad',
    'These restaurants belong to the neighborhoods they sit in. We show up for them, and we give back.': 'Estos restaurantes pertenecen a los vecindarios donde están. Estamos ahí para ellos y retribuimos.',
    'Ownership': 'Compromiso',
    'We run every shift like we own it, because we do. See it, fix it, take pride in it.': 'Manejamos cada turno como si fuera nuestro, porque lo es. Míralo, arréglalo, siéntete orgulloso de él.',
    // ===== header nav / footer links =====
    'Locations': 'Ubicaciones',
    'Values': 'Valores',
    'FAQ': 'Preguntas',
    'Apply now →': 'Postúlate →',
    'Apply': 'Postúlate',
    // ===== locations =====
    'Our locations': 'Nuestras ubicaciones',
    'Two restaurants. One team.': 'Dos restaurantes. Un solo equipo.',
    'Both restaurants are open and serving today. We’re hiring for both, and the people we hire now set the standard under new local ownership.': 'Ambos restaurantes están abiertos y atendiendo hoy. Estamos contratando para los dos, y las personas que contratamos ahora marcan el estándar con los nuevos dueños locales.',
    'New local owner from Oct 2026 · Hiring now': 'Nuevo dueño local desde oct. 2026 · Contratando',
    'Address coming soon': 'Dirección próximamente',
    'Join this crew →': 'Únete a este equipo →',
    // ===== form location field =====
    'Which location?': '¿Qué ubicación?',
    'Either works': 'Cualquiera me sirve',
    // ===== FAQ =====
    'Good questions': 'Buenas preguntas',
    'Everything you’re wondering, answered.': 'Todo lo que te preguntas, respondido.',
    'Don’t see your question? Ask us anything at': '¿No ves tu pregunta? Escríbenos a',
    'How old do I need to be to apply?': '¿Qué edad necesito para postularme?',
    'Many crew roles start at 14 or 15 with a Wisconsin work permit, and more stations open up at 16. If you’re not sure where you’d fit, send the form anyway and we’ll figure it out together.': 'Muchos puestos de equipo empiezan a los 14 o 15 años con un permiso de trabajo de Wisconsin, y a los 16 se abren más estaciones. Si no estás seguro de dónde encajas, envía el formulario de todos modos y lo resolvemos juntos.',
    'Do I need experience?': '¿Necesito experiencia?',
    'No. Most crew start with zero restaurant experience. We teach everything, and you bring the energy.': 'No. La mayoría del equipo empieza sin experiencia en restaurantes. Nosotros enseñamos todo, y tú pones la energía.',
    'How does hiring work?': '¿Cómo funciona la contratación?',
    'Three easy steps: send the interest form, we reach out fast for a quick conversation, and then you meet a manager in person. No résumé needed to start.': 'Tres pasos sencillos: envía el formulario de interés, te contactamos rápido para una conversación breve y luego conoces a un gerente en persona. No necesitas currículum para empezar.',
    'Aren’t these restaurants already open?': '¿No están abiertos ya estos restaurantes?',
    'Yes. Both restaurants are open and serving, and Our Restaurant Group is their new local owner starting October 2026. We’re taking applications now for jobs with us, and training is paid, like every hour you work.': 'Sí. Ambos restaurantes están abiertos y atendiendo, y Our Restaurant Group es su nuevo dueño local a partir de octubre de 2026. Ya estamos recibiendo solicitudes para trabajar con nosotros, y la capacitación es pagada, como cada hora que trabajas.',
    'What about pay and raises?': '¿Y el pago y los aumentos?',
    'Competitive hourly pay with regular reviews, plus free meals on shift and real promotion paths. We’ll talk specifics in your first conversation.': 'Pago por hora competitivo con revisiones regulares, más comidas gratis en turno y caminos reales de ascenso. Hablamos de detalles en tu primera conversación.',
    'Can I work in Spanish?': '¿Puedo trabajar en español?',
    'Yes. Our teams work in English and Spanish, so apply in whichever language feels right. The main site switches with the EN/ES button on your screen.': 'Sí. Nuestros equipos trabajan en inglés y en español, así que postúlate en el idioma que prefieras. El sitio principal cambia con el botón EN/ES en tu pantalla.',
    // ===== 404 =====
    'Off the': 'Fuera del',
    'Menu.': 'Menú.',
    'This page doesn’t exist, but the fries do. Let’s get you back on track.': 'Esta página no existe, pero las papas sí. Volvamos al camino.',
    'Back to home →': 'Volver al inicio →',
    'Apply for a role': 'Postúlate a un puesto'
  };

  var PH = {
    'Enter password': 'Escribe la contraseña',
    'Your experience, availability, when you can start...': 'Tu experiencia, disponibilidad, cuándo puedes empezar...'
  };

  /* ---- aria-label translations (screen-reader names that are not text nodes) ---- */
  var ARIA = {
    'Crew Radio: happy, positive tunes': 'Crew Radio: música alegre y positiva'
  };

  /* Text roots: every .mcdw section, plus the floating Crew Radio chip, which the chip
     section renders outside any .mcdw wrapper. */
  var ROOTS = '.mcdw, .mrc-chip';

  var htmlEls = [];
  function applyHTML(lang) {
    if (lang === 'es') {
      [].forEach.call(document.querySelectorAll('.mcdw h1,.mcdw h2,.mcdw p'), function (el) {
        if (el.__i18nHtml) return;
        var es = HTML[norm(el.textContent)];
        if (es && es.indexOf('{W}') >= 0) {
          var wm = el.querySelector('.wmk');
          es = wm ? es.replace('{W}', wm.outerHTML) : null;
        }
        if (es) { el.__en = el.innerHTML; el.innerHTML = es; el.__i18nHtml = true; htmlEls.push(el); }
      });
    } else {
      htmlEls.forEach(function (el) { if (el.__i18nHtml) { el.innerHTML = el.__en; el.__i18nHtml = false; } });
      htmlEls = [];
    }
  }

  function applyTEXT(lang) {
    [].forEach.call(document.querySelectorAll(ROOTS), function (root) {
      var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
        acceptNode: function (n) {
          var p = n.parentElement; if (!p) return NodeFilter.FILTER_REJECT;
          if (p.closest('.wmk')) return NodeFilter.FILTER_REJECT;
          var t = p.tagName; if (t === 'SCRIPT' || t === 'STYLE') return NodeFilter.FILTER_REJECT;
          return NodeFilter.FILTER_ACCEPT;
        }
      });
      var n;
      while (n = w.nextNode()) {
        if (lang === 'es') {
          if (n.__i18n) continue;
          var es = TEXT[norm(n.nodeValue)];
          if (es) {
            var raw = n.nodeValue, lead = raw.match(/^\s*/)[0], tr = raw.match(/\s*$/)[0];
            n.__en = raw; n.nodeValue = lead + es + tr; n.__i18n = true;
          }
        } else if (n.__i18n) {
          n.nodeValue = n.__en; n.__i18n = false;
        }
      }
    });
  }

  function applyPH(lang) {
    [].forEach.call(document.querySelectorAll('.mcdw [placeholder]'), function (el) {
      if (lang === 'es') {
        var es = PH[el.getAttribute('placeholder')];
        if (es && el.__ph == null) { el.__ph = el.getAttribute('placeholder'); el.setAttribute('placeholder', es); }
      } else if (el.__ph != null) { el.setAttribute('placeholder', el.__ph); el.__ph = null; }
    });
  }

  function applyARIA(lang) {
    [].forEach.call(document.querySelectorAll('.mcdw [aria-label], .mrc-chip[aria-label]'), function (el) {
      if (lang === 'es') {
        var es = ARIA[el.getAttribute('aria-label')];
        if (es && el.__aria == null) { el.__aria = el.getAttribute('aria-label'); el.setAttribute('aria-label', es); }
      } else if (el.__aria != null) { el.setAttribute('aria-label', el.__aria); el.__aria = null; }
    });
  }

  var curLang = 'en', obs = null, tmr = null;
  function reapply() { obs && obs.disconnect(); applyHTML('es'); applyTEXT('es'); applyPH('es'); applyARIA('es'); startObs(); }
  function schedule() { clearTimeout(tmr); tmr = setTimeout(reapply, 45); }
  function startObs() {
    if (!obs) obs = new MutationObserver(function (muts) {
      if (curLang !== 'es') return;
      // ignore the ticking clock so it doesn't trigger a full re-translate every second
      var relevant = muts.some(function (m) {
        var el = m.target && m.target.nodeType === 1 ? m.target : (m.target && m.target.parentElement);
        return !(el && el.closest && el.closest('.topclock'));
      });
      if (relevant) schedule();
    });
    obs.observe(document.body, { subtree: true, childList: true, characterData: true });
  }

  function setLang(lang) {
    curLang = lang;
    try { localStorage.setItem('mcdw-lang', lang); } catch (e) {}
    document.documentElement.setAttribute('lang', lang);
    if (obs) obs.disconnect();
    applyHTML(lang); applyTEXT(lang); applyPH(lang); applyARIA(lang);
    if (lang === 'es') startObs();
    if (window.mcdwRenderClock) window.mcdwRenderClock();
    var t = document.getElementById('mcdw-lang');
    if (t) [].forEach.call(t.children, function (b) { b.classList.toggle('on', b.dataset.lang === lang); });
  }

  function buildToggle() {
    if (document.getElementById('mcdw-lang')) return;
    var box = document.createElement('div');
    box.id = 'mcdw-lang'; box.setAttribute('role', 'group'); box.setAttribute('aria-label', 'Language / Idioma');
    ['en', 'es'].forEach(function (l) {
      var b = document.createElement('button');
      b.type = 'button'; b.dataset.lang = l; b.textContent = l.toUpperCase();
      b.addEventListener('click', function () { setLang(l); });
      box.appendChild(b);
    });
    document.body.appendChild(box);
  }

  function init() {
    if (!document.querySelector('.mcdw')) return;
    buildToggle();
    var saved = 'en';
    try { saved = localStorage.getItem('mcdw-lang') || 'en'; } catch (e) {}
    setLang(saved);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
